import { render, staticRenderFns } from "./smooth-height.vue?vue&type=template&id=70c1c0dc&scoped=true"
import script from "./smooth-height.ts?vue&type=script&lang=ts&external"
export * from "./smooth-height.ts?vue&type=script&lang=ts&external"
import style0 from "./smooth-height.vue?vue&type=style&index=0&id=70c1c0dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c1c0dc",
  null
  
)

export default component.exports